import React from 'react';
import PropTypes from 'prop-types';
import { Badge } from '@trailhead-emu/design-system';

// The "Beta Feature" tag shown between the mascot and title across the agent-chat
// system states (welcome, unauthenticated, no-org, error). It's the single home
// for the tag's config — a design-system Badge (variant="info" size="small") — plus
// its placement. The `.tds2-beta-tag` class carries layout only (centering + spacing
// below); it's the last tie to the retiring shim SCSS and folds in here once the
// shim is fully removed (W-23863623).
export default function BetaTag({ className, label = 'Beta Feature', ...rest }) {
  const cls = className ? `tds2-beta-tag ${className}` : 'tds2-beta-tag';
  return (
    <Badge variant="info" size="small" className={cls} {...rest}>
      {label}
    </Badge>
  );
}

BetaTag.propTypes = {
  className: PropTypes.string,
  label: PropTypes.node,
};
